import { makeTextComponent } from './makeTextComponent'

export const Detail = makeTextComponent(
  'font-size-normal font-weight-medium font-family-normal margin-bottom-12'
)
